<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card style="text-align: center; background: #f5f5f6; border-radius: 2px">
      <v-card-actions style="padding-bottom: 0px">
        <v-spacer></v-spacer>

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>

      <v-card-text>
        <v-form v-on:submit.prevent>
          <div class="font--p-sm px-8 mb-sm-6 mb-4">
            Для подтверждения введите код, который вы получили на номер {{ formattedPhone }}
          </div>

          <div class="code">
            <v-text-field
              :error="errdesc.length > 0"
              :error-messages="errdesc"
              autofocus
              placeholder="0000"
              style="font-size: 40px"
              v-mask="'####'"
              label="Код из смс"
              v-model="code"
              flat
              solo
              type="text"
              :disabled="currentTime === 0"
            ></v-text-field>
          </div>
        </v-form>
      </v-card-text>
      <div v-if="currentTime !== null">
        <v-card-text v-if="currentTime > 0"> Выслать код повторно через {{ currentTimeFormatted }}</v-card-text>

        <v-card-text v-else class="font--paragraph--xsmall">
          Время ввода кода истекло.
          <a :disabled="currentTime > 0" @click="refreshCode" href="#">Выслать код повторно</a>
        </v-card-text>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  data() {
    return {
      currentTime: null,
      timer: null,
    };
  },
  watch: {
    code(code, oldCode) {
      if (code && code.length === 4 && code !== oldCode && (!oldCode || oldCode.length < 4)) {
        this.makeWithdraw();
      }

      if (this.errdesc.length > 0) {
        this.clearErrdesc();
      }
    },

    currentTime(time) {
      if (time === 0) {
        this.stopTimer();
      }
    },

    dialog(current) {
      if (current === false) {
        // Очищаем стейт и сбрасываем таймер при закрытии модалки
        this.$store.dispatch("billing/resetWithdraw");
        this.stopTimer();
      } else {
        // в окне выводится ошибка из common/errdesc, очищаем старые ошибки при открытии модалки
        this.$store.dispatch("common/clearErrdesc");
        // В случае повторного запроса до истечения сессии приходит остаток сессии в секундах
        // Устанавливаем таймер завершения сессии
        if (this.resend_delay) {
          this.currentTime = this.resend_delay;
        } else {
          this.currentTime = 180;
        }
        this.startTimer();
      }
    },
  },
  computed: {
    ...mapGetters("profile", ["formattedPhone"]),
    ...mapGetters("common", ["errdesc"]),
    ...mapState("billing", ["resend_delay"]),

    currentTimeFormatted() {
      const sec = this.currentTime % 60;
      const min = Math.floor(this.currentTime / 60);
      let result = "";
      if (min > 0) {
        result += `${min} мин. `;
      }
      result += `${sec} сек.`;
      return result;
    },

    dialog: {
      get() {
        return this.$store.state.billing.withdrawalConfirmModal;
      },
      set(value) {
        this.$store.commit("billing/showWithdrawalConfirmModal", value);
      },
    },
    code: {
      get() {
        return this.$store.state.billing.code;
      },
      set(value) {
        this.$store.commit("billing/setWithdrawalCode", value);
      },
    },
  },
  methods: {
    ...mapActions("common", ["clearErrdesc"]),
    async makeWithdraw() {
      await this.$store.dispatch("billing/makeWithdraw");
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.currentTime--;
      }, 1000);
    },
    stopTimer() {
      clearTimeout(this.timer);
    },

    async refreshCode() {
      this.$store.dispatch("billing/resetWithdraw");
      await this.makeWithdraw();
      this.currentTime = 180;
      this.startTimer();
    },
  },
};
</script>
<style scoped>
.code {
  width: 140px;
  margin-left: auto;
  margin-right: auto;
}

.code >>> input {
  letter-spacing: 8px;
}
</style>
